import config from "devextreme/core/config";

config({
    editorStylingMode: 'underlined' // or 'outlined' | 'underlined'
})